import { Link, useLocation } from "@tanstack/react-router";
import type { ComponentType, ReactNode } from "react";
import { cx } from "@/utils/cx";

export type VerticalTab = {
  id: string;
  label: string;
  icon?: ComponentType<{ className?: string }>;
};

type VerticalTabsProps = {
  tabs: VerticalTab[];
  basePath: string;
  children: ReactNode;
};

export const VerticalTabs = ({ tabs, basePath, children }: VerticalTabsProps) => {
  const location = useLocation();
  const currentHash = location.hash || tabs[0]?.id;

  return (
    <div className="flex flex-row gap-8 flex-1 min-h-0">
      <nav className="flex flex-col w-48 shrink-0">
        {tabs.map((tab) => {
          const isActive = currentHash === tab.id;
          return (
            <Link
              key={tab.id}
              to={basePath}
              hash={tab.id}
              className={cx(
                "flex items-center gap-2 px-3 py-2 text-sm font-medium transition-colors border-l-2",
                isActive
                  ? "border-brand-primary_alt text-primary bg-transparent"
                  : "border-transparent text-tertiary hover:text-secondary",
              )}
            >
              {tab.icon && <tab.icon className="size-4" />}
              {tab.label}
            </Link>
          );
        })}
      </nav>
      <div className="flex-1 min-h-0 overflow-auto relative">{children}</div>
    </div>
  );
};

type TabPanelProps = {
  id: string;
  activeTab: string;
  children: ReactNode;
};

export const TabPanel = ({ id, activeTab, children }: TabPanelProps) => {
  if (activeTab !== id) return null;
  return <>{children}</>;
};
